import Moment from "moment";
import * as utils  from "../utils"
export default async function createDefaults(data,fields,context,master={},token="",excludeData=[]){
  if(!fields) return;
  await Promise.all(fields.filter(field=>!!field.default && excludeData.indexOf(field.default)<0 && field.type!=="Link" && field.type!=="Action").map(async (field) => {
    if(typeof(field.default)!=="string"){
      return {[field.field || field.name]:field.default};
    }
    let bodyFunction = `return (async ()=>{
      ${field.default.toString().indexOf("return ")>=0?field.default:`return ${field.default}`}
    })()`;

    try{
      const func= new Function("master","API","Moment","token","context","utils",bodyFunction);
      let value= await func(master,context.apis,Moment,token,context,utils);
      switch (field.type) {
        case "String":
          value= (value||"").toString();
          break;
        case "Number":
          value= Number(value||0);
          break;
        case "Date":
          if(typeof(value)!=="object"){
            value = new Date(value);
          }
          break;
        default:
      }
      data[field.field ||  field.name] = value;
      return {[field.field || field.name]:value};
    }catch(e){
      console.error("[CreateDefaults] error:",e.message,field.default);
      return {[field.field || field.name]:null};
    }

  })
 )
}
